import script from "./AdminStreamSettingsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminStreamSettingsPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminStreamSettingsPage.vue?vue&type=style&index=0&id=f82c4950&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f82c4950"]])

export default __exports__